import React, { useState } from 'react';
import { useFetchedTenantNotificationSettings } from '../hooks/useFetchedTenantNotificationSettings';
import { useUpdateTenantNotificationSettingsMutation } from '../hooks/useUpdateTenantNotificationSettingsMutation';
import { v4 as uuid } from 'uuid';
import { billingPortalConfig } from '../../commons/config';
import { SmsNotificationsModal } from './SmsNotificationsModal';

const source = 'billing';

export const SmsNotificationSwitch = () => {
  const {
    query: { data: notificationSettings },
    queryStatusComponent,
  } = useFetchedTenantNotificationSettings();

  const { mutate: updateTenantNotificationSettings } =
    useUpdateTenantNotificationSettingsMutation(source);
  const [modalKey, setModalKey] = useState<string | null>(null);

  if (!billingPortalConfig.isSmsNotificationsFeatureEnabled) return null;
  return notificationSettings ? (
    <>
      <div className="switch-input-container w-100">
        <input
          type="checkbox"
          className="custom-control-input"
          id="billing__sms-enabled"
          data-test="billing__sms-enabled-input"
          onChange={(e) => {
            if (e.target.checked) setModalKey(uuid());
            else updateTenantNotificationSettings({ smsEnabled: false });
          }}
          checked={notificationSettings.smsEnabled ?? false}
        />
        <label
          className="custom-control-label calendar-display-settings__check-label billing__sms-toggle"
          htmlFor="billing__sms-enabled"
          data-test="billing__sms-enabled-toggle"
        >
          Receive text reminders for Growegy invoices
        </label>
      </div>
      {modalKey && <SmsNotificationsModal key={modalKey} source={source} />}
    </>
  ) : (
    queryStatusComponent
  );
};
